import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import { LocalStorage } from '../../_api/localstorage';
import { SharedHttpService } from '../../services/shared-http.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  loading: boolean = false;
  public userRoleId: any;
  public rolesArr: any = [];

  public elem: any;
  public dark: boolean = this.layout.config.settings.layout_version == 'dark-only' ? true : false;

  constructor(public layout: LayoutService,public navServices: NavService, public sharedService: SharedHttpService,public router: Router, private toastr: NotificationService,
    @Inject(DOCUMENT) private document: any
  ) {
  }

  ngOnInit() {
    this.elem = document.documentElement;
    this.rolesArr = JSON.parse(localStorage.getItem("user")).userRoles;
      this.rolesArr.forEach(r => {
          if (r.branchName != null && r.branchName != "")
              r.FullroleName = r.roleName + " - " + r.branchName;
          else if (r.regionName != null && r.regionName != "")
              r.FullroleName = r.roleName + " - " + r.regionName;

          else if (r.committeeName != null && r.committeeName != "")
              r.FullroleName = r.roleName + " - " + r.committeeName;


          else if (r.organizationName != null && r.organizationName != "")
              r.FullroleName = r.roleName + " - " + r.organizationName;

          else
              r.FullroleName = r.roleName;


      if (r.lastSelected == true) {
          this.userRoleId = r.userRoleId;
          // this.sharedService.CurrentUserRoleId = r.userRoleId;
          // this.sharedService.CurrentRoleId = r.roleId;
      }
    });
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    this.navServices.megaMenu  = false;
    this.navServices.levelMenu = false;
  }
  selectUserRole(e) {
    this.loading = true;
    this.sharedService.get("api/Account/GetUserAuthTicket?UserRoleId=" + e.userRoleId).subscribe(result => {

      LocalStorage.user = JSON.stringify(result);

      this.sharedService.post("api/Account/RefreshToken", { refreshToken: LocalStorage.AccessToken.refresh_token }).subscribe(result2 => {
        if (result2.access_token != null) {
          LocalStorage.AccessToken = { access_token: result2.access_token, refresh_token: result2.refresh_token };
          if (this.router.url != '/home')
            this.router.navigate(['/home']).then(() => { window.location.reload() });
          else
            window.location.reload();
        }
        this.loading = false;
      });

    },
      error => {

        this.toastr.showError(error, '');

      });
  }

  layoutToggle() {
    this.dark = !this.dark;
    this.layout.config.settings.layout_version = this.dark ? 'dark-only' : 'light';
  }

  searchToggle() {
    this.navServices.search = true;
  }

  languageToggle() {
    this.navServices.language = !this.navServices.language;
  }

  toggleFullScreen() {
    this.navServices.fullScreen = !this.navServices.fullScreen;
    if (this.navServices.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (!this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }


}
